/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TeacherLoadRow } from './TeacherLoadRow';
import {
    TeacherLoadRowFromJSON,
    TeacherLoadRowFromJSONTyped,
    TeacherLoadRowToJSON,
    TeacherLoadRowToJSONTyped,
} from './TeacherLoadRow';

/**
 * 
 * @export
 * @interface WidgetDataTeacherLoadWidgetData
 */
export interface WidgetDataTeacherLoadWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataTeacherLoadWidgetData
     */
    $type?: WidgetDataTeacherLoadWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<TeacherLoadRow>}
     * @memberof WidgetDataTeacherLoadWidgetData
     */
    items: Array<TeacherLoadRow>;
}


/**
 * @export
 */
export const WidgetDataTeacherLoadWidgetDataTypeEnum = {
    TeacherLoad: 'teacher-load'
} as const;
export type WidgetDataTeacherLoadWidgetDataTypeEnum = typeof WidgetDataTeacherLoadWidgetDataTypeEnum[keyof typeof WidgetDataTeacherLoadWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataTeacherLoadWidgetData interface.
 */
export function instanceOfWidgetDataTeacherLoadWidgetData(value: object): value is WidgetDataTeacherLoadWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataTeacherLoadWidgetDataFromJSON(json: any): WidgetDataTeacherLoadWidgetData {
    return WidgetDataTeacherLoadWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataTeacherLoadWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataTeacherLoadWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(TeacherLoadRowFromJSON)),
    };
}

export function WidgetDataTeacherLoadWidgetDataToJSON(json: any): WidgetDataTeacherLoadWidgetData {
    return WidgetDataTeacherLoadWidgetDataToJSONTyped(json, false);
}

export function WidgetDataTeacherLoadWidgetDataToJSONTyped(value?: WidgetDataTeacherLoadWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(TeacherLoadRowToJSON)),
    };
}

